import Link from 'next/link';
import { FC } from 'react';
import cn from 'classnames';
export interface AmplienceHeadlineProps {
  title?: string;
  url?: string;
  openInANewTab?: boolean;
  hierarchy?: 'H1' | 'H2' | 'H3' | 'H4' | 'H5' | 'H6';
}

const headingStyles = {
  H1: 'text-3xl font-semibold text-center pt-14 mb-5 pb-3 uppercase relative after:content-[""] after:absolute after:bottom-0 after:left-1/2 after:-translate-x-1/2 after:w-[200px] after:h-px after:bg-gold',
  H2: 'text-2xl font-semibold text-center pt-6 pb-4 uppercase',
  H3: 'text-lg font-semibold text-center pt-4 pb-2 uppercase',
  H4: 'text-base font-semibold text-left pt-4 pb-2',
  H5: 'text-base font-normal text-left pt-4 pb-2',
  H6: 'text-sm font-normal text-left pt-4 pb-2',
};

const AmplienceHeadline: FC<AmplienceHeadlineProps> = ({ title, hierarchy = 'H1', url, openInANewTab, ...rest }) => {
  const HeadingTag = hierarchy.toLowerCase() as keyof JSX.IntrinsicElements;

  const renderTitle = url ? (
    <Link
      className="hover:underline"
      href={url}
      target={openInANewTab ? '_blank' : '_self'}
      rel="noopener noreferrer"
      aria-label={title}
    >
      {title}
    </Link>
  ) : (
    <>{title}</>
  );

  return (
    <div
      data-testid="headline-container"
      className={cn('flex', {
        'justify-center': hierarchy === 'H1' || hierarchy === 'H2' || hierarchy === 'H3',
      })}
    >
      {hierarchy === 'H2' && <div className="mr-5 mt-10 h-px grow bg-gold" data-testid="headline-divider-left" />}
      <HeadingTag className={cn(headingStyles[hierarchy], 'max-w-[80%]')}>{renderTitle}</HeadingTag>
      {hierarchy === 'H2' && <div className="ml-5 mt-10 h-px grow bg-gold" data-testid="headline-divider-right" />}
    </div>
  );
};
export default AmplienceHeadline;
